export const initialize = (inputContainer) => {
    let labelRoom = inputContainer.querySelector('.remodel-size-label');
    let ul = inputContainer.querySelector('.select2-selection__rendered');
    console.log(ul)
    let textArea = inputContainer.querySelector('.select2-search__field');
    console.log(textArea)
    textArea.addEventListener('blur', () => {
        if(ul.childElementCount !== 0) {
            labelRoom.classList.add('remodel-size-label-active')
            labelRoom.classList.remove('remodel-size-label')
        } else {
            labelRoom.classList.remove('remodel-size-label-active')
            labelRoom.classList.add('remodel-size-label')
        }
    })
}

